import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";

export const SUPPORTED_LANGUAGES = ["en", "fr", "es", "ar"];
export const RTL_LANGUAGES = ["ar"];
const STORAGE_KEY = "waveo_lang";

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  ar: { translation: ar },
};

// Reflect the active language on the <html> element so that Tailwind's
// direction-aware utilities and the browser both handle RTL correctly.
export function applyDirection(lng) {
  const base = (lng || "en").split("-")[0];
  const dir = RTL_LANGUAGES.includes(base) ? "rtl" : "ltr";
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", base);
  }
  return dir;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true, // maps "fr-FR" -> "fr", etc.
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      // Persisted choice first, then the browser language on first visit.
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

// Keep document direction in sync with the current language.
applyDirection(i18n.language);
i18n.on("languageChanged", (lng) => applyDirection(lng));

export default i18n;
